export default __webpack_public_path__ + "3815873eb00f52c688dbe210fb40dad2.svg";